import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss']
})
export class UploadDialogComponent {

  ACCEPT_FILE = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv';

  title = this.translate.instant('BUTTON.UPLOAD_FILE');
  fileUploaded = false;
  files: any[] = [];

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /**
  * on file drop handler
  */
  onFileDropped($event: any): void {
    if (this.files.length === 0 && $event && $event[0].type && this.ACCEPT_FILE.includes($event[0].type)) {
      this.prepareFilesList($event);
    }

  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler($event: any) {
    let files = $event.target.files;
    if (!!files) {
      this.prepareFilesList(files);
    }

  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    if (this.fileUploaded === false) {
      return;
    }
    this.files.splice(index, 1);
    this.fileUploaded = false;
  }

  /**
  * Simulate the upload process
  */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          try {
            if (this.files[index].progress === 100) {
              clearInterval(progressInterval);
              this.fileUploaded = true;
              this.uploadFilesSimulator(index + 1);
            } else {
              this.files[index].progress += 5;
            }
          }
          catch (error) { }
        }, 200);
      }
    }, 1000);
  }

  /**
  * Convert Files list to normal array list
  * @param files (Files List)
  */
  prepareFilesList(files: any) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   */
  formatBytes(bytes: number) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadFile() {

    if (this.fileUploaded === false) {
      return;
    }

    const file = this.files[0];
    if (file) {
      this.dialogRef.close(file);
    }
  }
}
